import Chart from "../../../shared/chart/chart";
import {useEffect, useState} from "react";

const DashboardChart = () => {
    const [data, setData] = useState();
    useEffect(() => {
        setData({
            datasets:  [
                {
                    label: 'Cabin Alerts',
                    backgroundColor: "#63B9F9",
                    data: [20, 30, 40, 35, 15, 30, 25, 30, 35, 30, 20, 27, 20, 14, 26,
                        39, 30, 18, 19, 35, 40, 22, 35, 30, 45, 26, 30, 28, 29, 25, 20],

                },
                {
                    label: 'Road Alerts',
                    backgroundColor: "#F07979",
                    data: [16, 25, 30, 28, 8, 37, 32, 25, 45, 26, 20, 24, 22, 14, 30,
                        32, 35, 25, 16, 30, 25, 22, 25, 30, 25, 35, 40, 30, 29, 20, 22],

                }
            ],
            labels : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
        })
    }, []);

    return (
        <>
            <Chart data={data}
                   barPercentage={0.6}
                   categoryPercentage={0.6}
                   barRadius={15}
                   gridX={false}
                   gridY={false}
                   borderX={false}
                   borderY={false}
                   labelsY={false}
                   legend={true} legendFont={'sf-medium'} paddingTop={0}/>
        </>
    )
}

export default DashboardChart;
